module.exports = __webpack_public_path__ + "7d47967c43d357cf79a5953b4587f860.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/long.png
// module id = 2398
// module chunks = 0